import { Poll } from '../../models/polls/Poll';
import { Query } from '../../_base/actionBus/Query';

export class GetUnitPolls extends Query<Poll[]> {
    constructor() {
        super();
    }
}
